/* eslint-disable no-underscore-dangle */
import { NgFor } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { Observable } from 'rxjs';

@Component({
    selector: 'formly-multi-checkbox',
    templateUrl: './multi-checkbox.component.html',
    standalone: true,
    imports: [
        MatListModule,
        FormsModule,
        ReactiveFormsModule,
        NgFor,
    ],
})
export class FormlyMultiCheckboxComponent extends FieldType<FormlyFieldConfig> implements OnInit {
	selectOptions: any[] = [];

	public ngOnInit(): void {
		if (this.props.options instanceof Array) {
			this.selectOptions = this.props.options;
		} else if (this.props.options instanceof Observable) {
			this.props.options.subscribe((result) => {
				this.selectOptions = result;
			});
		}
	}
}
